import { render } from "./Title.vue?vue&type=template&id=24daa375&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"

import "./Title.vue?vue&type=style&index=0&id=24daa375&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24daa375"

export default script